import React from 'react';
// import { ImageCarousel } from './ui/image-carousel'; // Commented out - carousel disabled

// CAROUSEL CONFIGURATION - Commented out while using static background
// Per-image configuration example - customize each image individually
/*
const DEFAULT_IMAGES = [
  {
    src: '/images/hero/hero-bg-1.jpg',
    objectFit: 'contain' as const,
    objectPosition: 'right',
    scale: 0.9,
  },
  {
    src: '/images/hero/hero-bg-2.jpg',
    objectFit: 'contain' as const,
    objectPosition: 'right',
    scale: 0.9,
  },
  {
    src: '/images/hero/hero-bg-3.jpg',
    objectFit: 'cover' as const,
    objectPosition: 'center',
    scale: 1,
  },
  {
    src: '/images/hero/hero-bg-4.jpg',
    objectFit: 'contain' as const,
    objectPosition: 'right',
    scale: 0.85,
  },
  {
    src: '/images/hero/hero-bg-5.jpg',
    objectFit: 'cover' as const,
    objectPosition: 'center',
    scale: 0.9,
  },
];

interface ImageConfig {
  src: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  objectPosition?: string;
  scale?: number;
}
*/

interface HeroProps {
  // backgroundImages?: string[] | ImageConfig[]; // Commented out - carousel disabled
  // autoPlayInterval?: number; // Commented out - carousel disabled
  // imageObjectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'; // Commented out
  // imageObjectPosition?: string; // Commented out
  // imageScale?: number; // Commented out
  overlayOpacity?: number; // Overlay darkness 0-100
}

export default function Hero({
  // backgroundImages = DEFAULT_IMAGES,
  // autoPlayInterval = 5000,
  // imageObjectFit = 'contain',
  // imageObjectPosition = 'center',
  // imageScale = 0.9,
  overlayOpacity = 50,
}: HeroProps) {
  return (
    <section id="hero" className="relative overflow-hidden min-h-screen flex items-start md:items-center group">
      {/* Background - Static Image (Carousel commented out) */}
      <div className="absolute inset-0 z-0">
        {/* Static background image - hero-bg-3.jpg */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(/images/hero/hero-bg-3.jpg)',
          }}
        />

        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: `rgba(0, 0, 0, ${overlayOpacity / 100})` }}
        />

        {/* CAROUSEL COMMENTED OUT - Uncomment to re-enable
        <ImageCarousel
          images={backgroundImages}
          interval={autoPlayInterval}
          showControls={true}
          showIndicators={true}
          fadeTransition={true}
          objectFit={imageObjectFit}
          objectPosition={imageObjectPosition}
          imageScale={imageScale}
          overlayOpacity={overlayOpacity}
        />
        */}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-32 pb-20 sm:py-32">
        <div className="text-center lg:text-left max-w-3xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Hi, I'm{' '}
            <span className="text-blue-300">Alberto</span>
            <br className="sm:hidden" />{' '}
            <span className="text-blue-300">Menendez</span>
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-4">
            Cloud Deployed Engineer | Product Manager | Engineer
          </p>

          <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-8 max-w-2xl">
            MIT Sloan MBA Candidate passionate about building innovative tech solutions.
            Former AWS Cloud Deployed Engineer with experience across AI, ML, and cloud infrastructure.
          </p>

          <div className="flex flex-row gap-2 sm:gap-4 justify-center lg:justify-start">
            <a
              href="#contact"
              className="inline-block bg-blue-500 hover:bg-blue-600 text-white px-4 py-2.5 sm:px-8 sm:py-4 rounded-lg font-semibold transition text-center text-xs sm:text-base"
            >
              Get In Touch
            </a>
            <a
              href="#projects"
              className="inline-block bg-white/10 hover:bg-white/20 text-white border-2 border-white px-4 py-2.5 sm:px-8 sm:py-4 rounded-lg font-semibold transition text-center backdrop-blur-sm text-xs sm:text-base"
            >
              View My Work
            </a>
          </div>

          {/* Social Links - Hidden on mobile */}
          <div className="hidden sm:flex mt-8 sm:mt-12 gap-4 sm:gap-6 justify-center lg:justify-start">
            <a
              href="https://www.linkedin.com/in/alberto-menendez"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-300 transition"
              aria-label="LinkedIn"
            >
              <svg className="w-7 h-7 sm:w-8 sm:h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
            <a
              href="mailto:albemene@mit.edu"
              className="text-white hover:text-blue-300 transition"
              aria-label="Email"
            >
              <svg className="w-7 h-7 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <a href="#about" className="flex flex-col items-center text-white hover:text-blue-300 transition">
          <span className="text-sm mb-2">Scroll Down</span>
          <svg className="w-6 h-6 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </a>
      </div>
    </section>
  );
}
